import { CloudFile } from 'owa-attachment-file-types';
import {
    CreateSharingLinkFromFileProviderResult,
    GetODCSharingInfoResponse,
    TEXT_DIRECTORY_MIME_TYPE,
    UNDEFINED_EXPIRATION_DATE,
} from 'owa-fileprovider-link-services';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import { getSharingLinkKindFromCreateSharingLinkFromFileProviderResult } from './getSharingLinkKindFromCreateSharingLinkFromFileProviderResult';

export function createGetODCSharingInfoResponse(
    file: CloudFile,
    createLinkResult: CreateSharingLinkFromFileProviderResult
): GetODCSharingInfoResponse {
    return {
        ResultCode: AttachmentResultCode.Success,
        FileName: file.name,
        MimeType: file.isFolder ? TEXT_DIRECTORY_MIME_TYPE : file.type,
        SharingLinkKind: getSharingLinkKindFromCreateSharingLinkFromFileProviderResult(
            createLinkResult,
            file.providerType
        ),
        BlocksDownload: false,
        CanShareExternally: true,
        CanCreateAnonymousEditLink: true,
        CanCreateAnonymousViewLink: true,
        ExpirationDate:
            createLinkResult.expirationDateTime === UNDEFINED_EXPIRATION_DATE
                ? null
                : createLinkResult.expirationDateTime,
        OriginalUrl: null,
        Type: createLinkResult.link.type,
        providerFileId: file.fileId,
        location: file.location,
    };
}
